import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { EnvironmentService } from '../env/env.service';
import { GlobalService } from '../global/global.service';

// import { ContentManager } from '@23degrees/shared/manager/content/content.manager';

import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { catchError } from 'rxjs/internal/operators/catchError';
import { ContentService } from '../content/content.service';

/**
 * THIS IMPORT SHOULD BE MORE SPECIFIC AND REMOVED
 * But till all rxjs classes within the whole app arent using the pipe technic
 * this saved the frontend
 */
@Injectable({ providedIn: 'root' })
export class DataService {
  http = inject(HttpClient);
  private globalService = inject(GlobalService);
  private contentService = inject(ContentService);

  private envService: EnvironmentService = inject(EnvironmentService);

  MetaAPI = '/services/data/meta-data';
  MdcAPI = '/services/mdc/api/v1';
  mockData: any;
  remoteHost = '';

  getDataByIdPromise = async (dataId): Promise<any> => {
    const contentArray = Object.values(this.globalService.getContentStore());
    const content = contentArray.find((content) => content.typeSpecific.dataId === dataId);

    if (content?.typeSpecific.useBucket) {
      const cdnLink = this.globalService.getCDNLink();
      const dataLink = `${cdnLink}/${content.slug}/data/id/${dataId}.json`;

      return firstValueFrom(
        this.http
          .get<any>(dataLink, { headers: { NoAuth: 'true' } })
          .pipe(catchError((error) => this.http.get<any>(`${this.envService.PUBLIC_DATA_PATH}${dataId}`, { headers: { NoAuth: 'true' } }))),
      );
    }

    return firstValueFrom(this.http.get<any>(`${this.envService.PUBLIC_DATA_PATH}${dataId}`, { headers: { NoAuth: 'true' } }));

    // const res = await firstValueFrom(this.httpClient.get(url, { headers: { NoAuth: 'true' }, responseType: 'text' })).catch((error) => {
    //   console.log('getDataByIdPromise error', url, error);
    // });

    // console.log('getDataByIdPromise', url, res);
    // return res ? JSON.parse(res) : null;
  };
}
